import { animeFootLinks } from '@/mocks/animeData';

export default function Footer() {
  return (
    <footer className="w-full bg-primary-950 text-background-100">
      <div className="px-4 md:px-8 py-14 md:py-16">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-8 md:gap-10">
          <div className="lg:col-span-5">
            <div className="flex items-center gap-2">
              <span className="w-9 h-9 rounded-md bg-primary-500 text-background-50 flex items-center justify-center">
                <i className="ri-play-circle-fill text-xl"></i>
              </span>
              <span className="font-heading text-lg font-bold text-background-50">91动漫</span>
            </div>
            <p className="mt-4 text-xs md:text-sm text-background-200/80 leading-relaxed max-w-md">
              一个把作品、类型与更新状态集中整理的动漫入口页。按作品找、按榜单挑、按新番追，三种浏览方式都留在这一个页面里，
              省去反复搜地址的时间。
            </p>
            <div className="mt-5 flex flex-wrap gap-2">
              <span className="px-3 py-1 rounded-full text-xs bg-background-50/10 border border-background-50/20">
                在线观看导航
              </span>
              <span className="px-3 py-1 rounded-full text-xs bg-background-50/10 border border-background-50/20">
                全集资源整理
              </span>
              <span className="px-3 py-1 rounded-full text-xs bg-background-50/10 border border-background-50/20">
                高清画质入口
              </span>
            </div>
          </div>

          <div className="lg:col-span-7 grid grid-cols-1 sm:grid-cols-3 gap-8">
            {animeFootLinks.map((group) => (
              <div key={group.title}>
                <h4 className="font-heading text-sm font-bold text-background-50 mb-3">
                  <a href="#top" className="cursor-pointer hover:text-accent-300 transition-colors">
                    {group.title}
                  </a>
                </h4>
                <ul className="space-y-2">
                  {group.items.map((link) => (
                    <li key={link.label}>
                      <a
                        href={link.href}
                        className="text-xs md:text-sm text-background-200/75 hover:text-accent-300 transition-colors cursor-pointer"
                      >
                        {link.label}
                      </a>
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </div>
        </div>

        <div className="mt-12 pt-6 border-t border-background-50/15 flex flex-col sm:flex-row sm:items-center sm:justify-between gap-3">
          <p className="text-xs text-background-200/70">
            © 2026 91动漫 · 本页内容为本站整理的作品索引与观看指南
          </p>
          <p className="text-xs text-background-200/70">
            作品信息以实际播出为准，本页仅作浏览与分类参考
          </p>
        </div>
      </div>
    </footer>
  );
}